import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { errorHandler } from "#app/monitoring/errorHandler";
import { showErrorToast, showSuccessToast } from "#app/notifications";
import { downloadExportConsultation } from "#modules/quoteRequests/infra/exportConsultationZip.api";

export const useExportConsultationZip = () => {
  const { t } = useTranslation();

  const { mutate, ...rest } = useMutation({
    mutationFn: downloadExportConsultation,
    onSuccess: () => {
      showSuccessToast({
        title: t("quoteRequestLine.actions.exportConsultationZip.success"),
      });
    },
    onError: (err: unknown) => {
      if (err instanceof Error) {
        showErrorToast({ title: err.message });
        errorHandler(err);
      } else {
        showErrorToast({
          title: t("quoteRequestLine.actions.exportConsultationZip.unknownError"),
        });
      }
    },
  });

  return { exportConsultation: mutate, ...rest };
};
